import { FC } from "react";
import { Typography, RadioGroup, Radio, Box, Paper, Divider } from "@mui/material";
import { useAppSelector } from "shared/lib/hooks/hooks";
import { useTranslation } from "react-i18next";

import { useAppDispatch } from "shared/config/configureStore";
import { Controller, useFormContext } from "react-hook-form";
import { setIsInsuranceNeeded, setSelectedDistance } from "api/slice/marathonsSlice/marathonsSlice";

interface ISelectDistanceProps {
  changeDistance?: boolean;
}

const SelectDistance: FC<ISelectDistanceProps> = ({ changeDistance }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const marathon = useAppSelector((state) => state.marathons.marathonsById.response.data);
  const registrationInfo = useAppSelector((state) => state.marathons.userRegistered.data);

  const filteredDistances = marathon?.distances?.filter((item: any) => {
    const isRegistered = Number(registrationInfo?.distanceId) !== Number(item?.id);
    return isRegistered;
  });

  const distancesToShow = changeDistance ? filteredDistances : marathon?.distances;

  const { control } = useFormContext();

  return (
    <Paper
      sx={{
        borderRadius: "16px",
        padding: "24px",
        boxShadow: "none",
        width: "100%",
      }}
    >
      <Box display="flex" columnGap="16px" paddingBottom="16px">
        <Typography sx={{ fontSize: "20px", fontWeight: 600, marginBottom: "16px" }}>
          {t("registerToMarathon.selectDistance")}
        </Typography>
        <Divider
          sx={{
            flexGrow: 1,
            height: "1px",
            my: 2,
            backgroundColor: "#ECF2F7",
          }}
        />
      </Box>

      <Controller
        name="selectedDistance"
        control={control}
        rules={{ required: t("registerToMarathon.distanceMustBeSelected") }}
        render={({ field, fieldState }) => (
          <Box display="flex" flexDirection="column" gap={1}>
            <RadioGroup
              {...field}
              value={field.value || ""}
              onChange={(e) => {
                field.onChange(e);
                dispatch(setSelectedDistance(e.target.value));
                dispatch(setIsInsuranceNeeded(false));
              }}
            >
              {distancesToShow?.map((distance: any) => {
                const todayPrice = distance.distancePrices.find((p: any) => p.isToday);

                return (
                  <Box
                    key={distance.id}
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      cursor: "pointer",
                    }}
                  >
                    <Radio value={distance.id.toString()} />

                    <Box sx={{ display: "flex", alignItems: "center", width: "100%" }}>
                      <Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
                        {distance.name}
                      </Typography>

                      <Box sx={{ flexGrow: 1, height: "1px", backgroundColor: "#ECF2F7", mx: 1 }} />

                      <Typography sx={{ fontSize: "16px", fontWeight: 600 }}>
                        {todayPrice ? `${todayPrice.price} ${t("myMarathon.som")}` : "—"}
                      </Typography>
                    </Box>
                  </Box>
                );
              })}
            </RadioGroup>

            {fieldState.error && (
              <Typography color="error" variant="body2" sx={{ ml: 5 }}>
                {fieldState.error.message}
              </Typography>
            )}
          </Box>
        )}
      />
    </Paper>
  );
};

export default SelectDistance;
